export const OFFLINE_ENABLED_KEY = 'offlineEnabled';
export const OFFLINE_DISABLED_REASON_KEY = 'offlineDisabledReason';
